import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const logo = (
    <Box 
      component="img"
      src="/favicon/Phonix.png"
      alt="Phonix Logo"
      sx={{ 
        width: 40, 
        height: 40, 
        objectFit: 'contain',
        ...sx 
      }}
    />
  );

  return <RouterLink to="/">{logo}</RouterLink>;
}
